import { h } from 'preact';
import React from 'react';

import { RowSettings } from './RowSettings';
import Children from '../../messages/Notice/Children';
import { useDev } from '../../hooks';

import './Row.css';

export const Row = (props) => {
  let {
    component,
    className,
    width,
    preview,
    dev,
    path,
    makeChoice,
    language,
    siteId,
    message,
    events,
    preloadMsg,
    stacksData,
    updateStacks,
    consentUUID,
    allSelectionsMade,
    shown,
    setVendorCount,
    vendorCount
  } = props
  
  const settings = new RowSettings(component.settings);
  let { devActions, devClass, pathString } = useDev(path, dev);
  let extraClass = '';

  const styles = {
    ...settings.padding,
    ...settings.margin,
    ...settings.border,
    display: settings.display
  };

  if (dev) {
    if (component.children.length === 0) {
      styles.minHeight = '24px';
    };
    if (!dev.opts.hideRowColumnBorders) {
      devClass += ' on-dev';
    };
  };

  /* WIDTH & HEIGHT */
  const { paddingLeft, paddingRight } = settings.padding;
  const { marginLeft, marginRight } = settings.margin;
  styles.width = settings.width.type === 'auto' ? 'auto' : settings.width.value + settings.width.type;
  styles.height = settings.height.type === 'auto' ? 'auto' : settings.height.value + settings.height.type;
  if (settings.width.type === '%') {
    styles.width = `calc(${settings.width.value}% - ${(paddingLeft + paddingRight + marginLeft + marginRight)}px`
  };

  /* OTHER SETTINGS */
  styles.background = settings.background;
  styles.justifyContent = settings.align;
  styles.alignItems = settings.vertical;

  /* RESPONSIVE SETTINGS */
  if (width && width < 600 && !preview) {
    styles.flexDirection = 'column';
    styles.justifyContent = settings.vertical;
    styles.alignItems = settings.align;
  };

  if (settings.background_url && settings.background_url.length > 0) {
    delete styles.background;
    styles.backgroundImage = `url(${settings.background_url})`;
    extraClass += ' background-url';
  }

  return (
    <div
      className={'message-component message-row' + devClass + className + extraClass}
      path={dev ? pathString : null}
      style={styles}
      {...devActions}
    >
      <Children
        {...props}
        path={path}
        dev={dev}
        components={component.children}
        siteId={siteId}
        message={message}
        makeChoice={makeChoice}
        language={language}
        events={events}
        preloadMsg={preloadMsg}
        stacksData={stacksData}
        updateStacks={updateStacks}
        consentUUID={consentUUID}
        allSelectionsMade={allSelectionsMade}
        neutralPm={props.neutralPm}
        shown={shown}
        pmData={props.pmData}
        className={props.className}
        child={props.child}
        vendors={props.vendors}
        toggleCategory={props.toggleCategory}
        toggleStack={props.toggleStack}
        isFirstLayer={props.isFirstLayer}
        setVendorCount={setVendorCount}
        vendorCount={vendorCount}
      />
    </div>
  );
}